module.exports = __webpack_public_path__ + "static/media/blanket.6c7e2f0e.svg";